var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('div',[_c('el-button',{attrs:{"icon":"el-icon-back","type":"text","size":"small"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1),_c('meta-info',{attrs:{"guid":_vm.guid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }